import { createContext, use } from "react";
import type { Environment, InstallSetup, NotificationSetup } from "@safers/pwa";

export interface AppSetup {
  notification: NotificationSetup;
  // 배너는 이걸 쓰지 않는다 — 조르는 자리가 아니라 내 정보처럼 찾아 들어오는 자리용.
  install: InstallSetup;
  env: Environment;
  installed: boolean;
  dismissed: boolean;
  dismiss: () => void;
  /** 닫아 둔 안내를 다시 띄운다 — 계정 메뉴의 `알림 설정`. */
  reset: () => void;
}

// 값은 AppSetupProvider 가 채운다. 컴포넌트와 같은 파일에 두면 fast refresh 가 깨진다.
export const AppSetupContext = createContext<AppSetup | null>(null);

export function useAppSetup(): AppSetup {
  const value = use(AppSetupContext);
  if (!value) throw new Error("useAppSetup 은 AppSetupProvider 안에서만 쓸 수 있습니다");
  return value;
}
